import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import { createI18n } from './i18n';
import { localeFromPath, htmlLang } from './seo/routes';
import './styles.css';

const locale = localeFromPath(window.location.pathname);
const i18n = createI18n(locale);

document.documentElement.lang = htmlLang(locale);
if (!document.title) document.title = 'Rokas Sileikis';

const container = document.getElementById('root') as HTMLElement;

const app = (
  <I18nextProvider i18n={i18n}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </I18nextProvider>
);

if (container.childElementCount > 0) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
